import { Button, Carousel, CarouselItem, Container } from "reactstrap";
import resuturantBgDetail from "../../assets/resturant-detail-bg.png";
import Header from "../../components/globals/Header";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import ResturantBasicDetails from "../../components/page-sections/ResturantBasicDetails";
import {
  IoArrowBackOutline,
  IoArrowForwardOutline,
  IoFemale,
  IoMaleOutline,
} from "react-icons/io5";
import ResturantsDiscountsDetail from "../../components/page-sections/ResturantsDiscountsDetail";
import ResturantGalleryDetails from "../../components/page-sections/ResturantGalleryDetails";
import ResturantReviews from "../../components/page-sections/ResturantReviews";
import BookLet from "../../components/specials/BookLet";
import ResturantMenuCard from "../../components/page-sections/ResturantMenuCard";
import ResturantEventDetail from "../../components/page-sections/ResturantEventDetail";
import { useGoBack } from "../../utils";
import ResturantDeals from "../../components/page-sections/ResturantDeals";
import ResturantSpecialEvent from "../../components/page-sections/ResturantSpecialEvent";
import { useDispatch, useSelector } from "react-redux";
import { getPlaceDetailsApis } from "../../apis/PlacesApis";
import { setPlaceDetails } from "../../redux/action";
import { useTranslation } from "../../languages";
const ResturantDetail = () => {
  const { state } = useLocation();
  const goBack = useGoBack();
  const dispatch = useDispatch();
  console.log("Getting Details of .......",state);
  //other details are sent here
  const { t } = useTranslation();
  useEffect(() => {
    const apiCall = async () => {
      const response = await getPlaceDetailsApis(state?._id);
      if (response?.success) {
        dispatch(setPlaceDetails(response?.data));
      }
    };
    apiCall();
  }, []);
  const deals_Redux = useSelector((s) => s?.allDealsData);
  console.log("deals_Redux", { deals_Redux });
  const slideItems = [
    <ResturantBasicDetails />,
    <ResturantsDiscountsDetail details={state} />,
    <ResturantGalleryDetails />,
    <ResturantDeals details={state} />,
    // <ResturantSpecialEvent details={state} />,
    // <ResturantMenuCard details={state} />,
    <ResturantReviews />,
    // <ResturantEventDetail />,
  ];
  //
  console.log({ state });
  return (
    <div>
      <Container fluid>
        <Header title={t("myPlaces")} />
        <div
          style={{ minHeight: "50px" }}
          className="bg-white d-flex px-3  mb-4 align-items-center justify-content-between full-width"
        >
          <h5 className="f-6 color-primary-blue m-0">
            {state?.name}{" "}
            {state?.genderPreference?.[0] === "male" ? (
              <IoMaleOutline size={30} color="blue" />
            ) : state?.genderPreference?.[0] === "female" ? (
              <IoFemale size={30} color="rgb(157, 1, 85)" />
            ) : ""}
          </h5>
          <div className="d-flex align-items-center gap-3">
            <Link
              to={"/places/editplace"}
              state={state}
              className="btn text-white text-decoration-none standard-rounded-btn px-4  py-2 inner-shadow-white"
            >
              {t("edit")}
            </Link>
            <Button
              onClick={() => goBack()}
              className="standard-rounded-btn   py-2 inner-shadow-white"
            >
              {t("close")}
            </Button>
          </div>
        </div>
        <BookLet pageBackground={resuturantBgDetail} title={state?.name}>
          {slideItems?.map((item, key) => item)}
        </BookLet>
      </Container>
    </div>
  );
};
export default ResturantDetail;
